import React from 'react';

import { ErrorMessageConstants } from '@zg-rentals/rental-manager-env';
import { KeyCodeConstants } from '@zg-rentals/rental-manager-env';

import { Box, Button, ButtonGroup, Text, TextButton } from '@zillow/constellation-10';

export type ModalFooterProps = {
  onCancel?: () => void;
  onSubmit: () => void;
  submitText?: string;
  cancelText?: string;
  cancelType?: 'button' | 'submit' | 'reset' | undefined;
  errorMessage?: string;
  isSubmitting?: boolean;
  hasError?: boolean;
  isSubmitDisabled?: boolean;
};

// @ts-expect-error - event parameter needs proper typing
const onKeyUp = (event) => {
  if (event.keyCode === KeyCodeConstants.ENTER || event.keyCode === KeyCodeConstants.SPACE) {
    event.target.click();
  }
};

export const ModalFooter = ({
  onCancel,
  onSubmit,
  submitText = 'Confirm',
  cancelText = 'Cancel',
  cancelType = 'button',
  errorMessage = '',
  isSubmitting = false,
  hasError = false,
  isSubmitDisabled = false,
}: ModalFooterProps) => (
  <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
    {hasError && (
      <Box css={{ paddingBottom: '400' }}>
        <Text css={{ color: 'red.600' }}>{errorMessage || ErrorMessageConstants.DEFAULT_ERROR}</Text>
      </Box>
    )}
    <ButtonGroup aria-label="controls">
      {onCancel && (
        <TextButton
          data-test="cancel-button"
          aria-label="Cancel"
          tabIndex={0}
          tone="neutral"
          onClick={onCancel}
          onKeyUp={onKeyUp}
          disabled={isSubmitting}
          type={cancelType}
        >
          {cancelText}
        </TextButton>
      )}
      <Button
        data-test="submit-button"
        tone="brand"
        emphasis="filled"
        onClick={onSubmit}
        disabled={isSubmitDisabled}
        loading={isSubmitting}
        type="submit"
      >
        {submitText}
      </Button>
    </ButtonGroup>
  </Box>
);

export default ModalFooter;
